import React from "react";
import { motion } from "framer-motion";
import "./ServicesHero.css";
import { Link } from "react-router-dom"; // ✅ import for appointment navigation
const images = [
  "https://i.ibb.co/JWh3XBHV/image-7.png",
  "https://i.ibb.co/4gnm0QpZ/image-5.png",
  "https://i.ibb.co/C3fHj4Zv/image-4.png",
  "https://i.ibb.co/JWh3XBHV/image-7.png",
  "https://i.ibb.co/4gnm0QpZ/image-5.png",
  "https://i.ibb.co/C3fHj4Zv/image-4.png",
  "https://i.ibb.co/JWh3XBHV/image-7.png",
  "https://i.ibb.co/4gnm0QpZ/image-5.png",
  "https://i.ibb.co/C3fHj4Zv/image-4.png",
  "https://i.ibb.co/JWh3XBHV/image-7.png",
  "https://i.ibb.co/4gnm0QpZ/image-5.png",
  "https://i.ibb.co/C3fHj4Zv/image-4.png",
];

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const services = [
  { title: "Upper GI Endoscopy", img: "/images/services/upper-gi.jpg" },
  { title: "Colonoscopy", img: "/images/services/colonoscopy.jpg" },
  { title: "ERCP (Endoscopic Retrograde Cholangiopancreatography)", img: "/images/services/ercp.jpg" },
  { title: "Endoscopic Ultrasound (EUS)", img: "/images/services/eus.jpg" },
  { title: "Liver Disease Management", img: "/images/services/liver-management.jpg" },
  { title: "Capsule Endoscopy", img: "/images/services/capsule.jpg" },
  { title: "24-Hour pH Monitoring", img: "/images/services/ph-monitoring.jpg" },
  { title: "Manometry Testing", img: "/images/services/manometry.jpg" },
  { title: "Balloon Enteroscopy", img: "/images/services/balloon.jpg" },
  { title: "Hepatitis Screening & Vaccination", img: "/images/services/hepatitis.jpg" },
  { title: "H. Pylori Breath Test", img: "/images/services/breath-test.jpg" },
  { title: "Colon Cancer Screening", img: "/images/services/colon-cancer.jpg" },
  { title: "Fatty Liver Disease Treatment", img: "/images/services/fatty-liver.jpg" },
  { title: "Inflammatory Bowel Disease (IBD) Management", img: "/images/services/ibd.jpg" },
  { title: "GERD (Acid Reflux) Treatment", img: "/images/services/gerd.jpg" },
  { title: "Liver Biopsy", img: "/images/services/liver-biopsy.jpg" },
  { title: "Food Intolerance Testing", img: "/images/services/food-test.jpg" },
  { title: "GERD (Acid Reflux) Treatment", img: "/images/services/gerd2.jpg" },
];
const ServicesHero = () => {
  return (
    <section className="services-hero">
      {/* Hero Content */}
      <div className="services-hero-contents">
        <h1 className="services-hero-titles">
          World-Class Digestive & Liver Care at <br />
          <span>Krisara Gastro and Liver Clinic</span>
        </h1>
        <p className="services-hero-subtitles">
          Led by Dr. B. Shruti Sagar — Hyderabad's trusted gastroenterologist
          with 8 years of expertise and 500+ advanced procedures completed.
          Our state-of-the-art clinic in Fair Mount, Kompally offers the most
          comprehensive range of diagnostic and therapeutic services for all
          gut, liver, and pancreatic conditions.
        </p>
        <div className="services-hero-buttons">
<a href="tel:+919876543210">
  <button className="btn-black">Contact Us →</button>
</a>          
<Link to="/appointment">
  <button className="btn-orange">Book Appointment</button>
</Link>
        </div>
      </div>
      {/* Continuous Auto Carousel */}
      <div className="carousel-wrapper">
        <motion.div
          className="carousel-track"
          animate={{ x: ["0%", "-100%"] }}
          transition={{ repeat: Infinity, duration: 120, ease: "linear" }}
        >
          {[...images, ...images].map((img, idx) => (
            <div key={idx} className="carousel-item">
              <img src={img} alt={`service ${idx}`} />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
export default ServicesHero;